import AbstractClient from "../AbstractClient";
import config from "../../config";

export default abstract class AbstractCartClient extends AbstractClient {
    protected getBaseUrl(): string {
        return `${config.API_URL}/carts`;
    }
}
